import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { isWindowDefined } from '@core/Constants/Window';
import { deepGet } from '@core/Utils/DeepGet';
import { deepSet } from '@core/Utils/DeepSet';

import { setAdditionalServices, type Value } from '../Utils/setAdditionalServices';
import { finCalcDataAtom } from './FinCalcData.atom';

export const finCalcDataFieldValueAtom = atomFamily((fieldId: string) =>
  atom(
    get => {
      const finCalcData = get(finCalcDataAtom);

      // @ts-expect-error - window object does not have this type
      if (isWindowDefined) window.finCalcData = finCalcData;

      return deepGet(finCalcData, fieldId);
    },
    (get, set, value) => {
      let newData = deepSet(get(finCalcDataAtom), fieldId, value);

      if (fieldId === 'additionalServices')
        newData = setAdditionalServices(newData, value as Value);

      set(finCalcDataAtom, newData);
    },
  ),
);
